import offerService from '../../../services/offer-service'
import userService from "../../../services/user-service";

const GENERATE_OTP ='GENERATE_OTP'
const VALIDATE_OTP ='VALIDATE_OTP'

const LOAD_CUSTOMER_OFFERS = 'LOAD_CUSTOMER_OFFERS'

export function loadCustomerOffers(mobileNumber) {
  return (dispatch, getState) => {
    return offerService.getCustomerAvailableOffers(mobileNumber)
      .then((customerOffers) => {
        dispatch({
          type: LOAD_CUSTOMER_OFFERS,
          customerOffers: customerOffers
        })
      })
  }
}
export function generateOTP(sendOtpBody,key) {
  return (dispatch, getState) => {
    return userService.generateOTP(sendOtpBody,key).then((otp)=>{
      dispatch({
        type: GENERATE_OTP,
        otpInfo: otp
      })
    })
  }
}

export function validateOTP(body,key) {
  return (dispatch, getState) => {
    return userService.validateOTP(body,key).then((otp)=>{
      dispatch({
        type: VALIDATE_OTP,
        validatedOtpInfo: otp
      })
    })

  }
}


export function loadCustomerOffersReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_CUSTOMER_OFFERS : {
      return action.customerOffers
    }
    default :
      return state
  }
}


export function validateOTPReducer(state = {}, action) {
  switch (action.type) {
    case VALIDATE_OTP : {
      return action.validatedOtpInfo
    }
    default :
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/OfferActivation/modules/OfferActivation.js